import type { IconNode } from '../types';

/**
 * @name hat-top
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8ZWxsaXBzZSBjeD0iMTIiIGN5PSI1IiByeD0iNyIgcnk9IjMiIC8+CiAgPHBhdGggZD0iTTUgNWMwIDEgMSA0IDEgNnY0YzAgMS43IDIuNyAzIDYgM3M2LTEuMyA2LTN2LTRjMC0yIDEtNSAxLTYiIC8+CiAgPHBhdGggZD0iTTE4IDExYzAgMS43LTIuNyAzLTYgM3MtNi0xLjMtNi0zIiAvPgogIDxwYXRoIGQ9Ik02IDExLjJDMy42IDEyLjMgMiAxNCAyIDE2YzAgMy4zIDQuNSA2IDEwIDZzMTAtMi43IDEwLTZjMC0yLTEuNi0zLjctNC00LjgiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/hat-top
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const hatTop: IconNode = [
  ['ellipse', { cx: '12', cy: '5', rx: '7', ry: '3', key: '28783h' }],
  ['path', { d: 'M5 5c0 1 1 4 1 6v4c0 1.7 2.7 3 6 3s6-1.3 6-3v-4c0-2 1-5 1-6', key: '1ei7r3' }],
  ['path', { d: 'M18 11c0 1.7-2.7 3-6 3s-6-1.3-6-3', key: '1wjc2z' }],
  [
    'path',
    {
      d: 'M6 11.2C3.6 12.3 2 14 2 16c0 3.3 4.5 6 10 6s10-2.7 10-6c0-2-1.6-3.7-4-4.8',
      key: 'gb7psd',
    },
  ],
];

export default hatTop;
